import React, { useEffect } from "react";
import Card from "@/components/Card";
import DataTable from "@/components/ui/DataTable";
import { GetPayslipUserResult } from "@/models/payslips.model";
import { getUnprocessedAndItemsAddedPayslips } from "@/api/payslips";
import { months } from "@/utils/date-format";
import { getColumns } from "./column";
import { Button } from "@/components/ui/button";
import { RowSelectionState } from "@tanstack/react-table";
import { CustomDatePicker } from "@/components/form/CustomDatePicker";
import ProcessPayForm from "./ProcessPayForm";
import { usePayContext } from "@/context/PayContext";
import { Skeleton } from "@/components/ui/skeleton";
import { toast } from "@/hooks/use-toast";

function UnprocessPayDataTable() {
  const {
    selectedMonth,
    selectedYear,
    isUnprocessedListChanged,
    setIsUnprocessedListChanged,
  } = usePayContext();
  const [unprocessedPayUsers, setUnprocessedPayUsers] = React.useState<
    GetPayslipUserResult[]
  >([]);
  const [rowSelection, setRowSelection] = React.useState<RowSelectionState>({});

  const deleteUnprocessedRows = (usersToRemove: number[]) => {
    const updatedUsers = unprocessedPayUsers.filter(
      (user) => !usersToRemove.includes(user.user.id)
    );
    setUnprocessedPayUsers(updatedUsers);
  };

  useEffect(() => {
    const getData = async () => {
      if (selectedMonth && selectedYear) {
        try {
          const data = await getUnprocessedAndItemsAddedPayslips(
            Number(selectedYear),
            months.indexOf(selectedMonth) + 1
          );
          console.log(data);
          setUnprocessedPayUsers(data);
        } catch (err) {
          console.log(err)
          toast({
            variant: "destructive",
            title: "Failed to fetch unprocessed payslips",
            description: "Please try again later",
          })

        }
      }
    };
    getData();
  }, [selectedMonth, selectedYear]);

  useEffect(() => {
    const getData = async () => {
      if (isUnprocessedListChanged && selectedMonth && selectedYear) {
        const data = await getUnprocessedAndItemsAddedPayslips(
          Number(selectedYear),
          months.indexOf(selectedMonth) + 1
        );
        setUnprocessedPayUsers(data);
        setIsUnprocessedListChanged(false);
      }
    };
    getData();
  }, [isUnprocessedListChanged]);

  if (!selectedMonth || !selectedYear) {
    return <Skeleton className="h-full w-full " />;
  }
  return (
    <Card styles="w-full h-full">
      <div className="rounded-md w-full h-full p-5 bg-white outline outline-2 outline-gray-100 flex flex-col">
        <div className="flex-col mb-4 justify-between items-start w-full">
          <div className="flex flex-row gap-3 w-full justify-between items-start">
            <div className="font-bold mt-2 text-xl">Unprocessed List</div>
            <ProcessPayForm
              rowSelection={rowSelection}
              unprocessedPayUsers={unprocessedPayUsers}
              deleteUnprocessedRows={deleteUnprocessedRows}
              setRowSelection={setRowSelection}
            />
          </div>

          <div className="text-sm text-gray-500 mt-3">
            The following is a list of employees whose payslips are yet to be
            processed for the period: {selectedMonth} {selectedYear}. <br />{" "}
            Click on the action button to add pay items to their payslip.
          </div>
        </div>

        <div className="h-full max-h-full overflow-y-auto">
          <DataTable
            tableMinWidth="400px"
            columns={getColumns(selectedMonth, selectedYear)}
            data={unprocessedPayUsers}
            rowSelection={rowSelection}
            setRowSelection={setRowSelection}
            containerClassname="max-h-72" // Customizable styles
            tableCaption={`A total of ${unprocessedPayUsers.length} employees with unprocessed payslips.`}
          />
        </div>
      </div>
    </Card>
  );
}


export default UnprocessPayDataTable;